<template>
  <v-app>
   
    <header-two/>
    <v-main>
      <router-view/>
    </v-main>
    <footer-default></footer-default>
  </v-app>
</template>

<script>
import HeaderTwo from './components/layout/HeaderTwo.vue';
import FooterDefault from './components/layout/FooterDefault.vue';

export default {
  name: 'App',
  components:{
HeaderTwo,
FooterDefault
  },

  data: () => ({
    //
  }),
};
</script>
